(function () {
  if (document.documentElement.getAttribute('dir') !== 'rtl') return;

  var doc = document.documentElement;

  function instantScrollLeftReset(el) {
    if (!el || el.scrollLeft === 0) return;
    if (el.scrollTo) {
      // behavior:'instant' bypasses `scroll-behavior: smooth` set in global.css;
      // a plain scrollLeft assignment would animate and look like a drift.
      el.scrollTo({ left: 0, top: el.scrollTop, behavior: 'instant' });
    }
    if (el.scrollLeft !== 0) el.scrollLeft = 0;
  }

  function resetHorizontalScroll() {
    instantScrollLeftReset(doc);
    instantScrollLeftReset(document.body);
  }

  // Catch any horizontal scroll of the document the moment it happens
  // (focus() on off-canvas drawers, anchor jumps, smooth-scroll drift).
  // Scroll events don't bubble, so listen in the capture phase.
  document.addEventListener(
    'scroll',
    function (e) {
      var t = e.target;
      if (t === document || t === doc || t === document.body) {
        resetHorizontalScroll();
      }
    },
    true
  );

  // Focus moving into off-canvas panels is the main trigger for the sideways
  // shove; the scroll it causes can land before a scroll event is observable.
  document.addEventListener('focusin', function () {
    window.requestAnimationFrame(resetHorizontalScroll);
  });

  window.addEventListener('load', resetHorizontalScroll);
  window.addEventListener('resize', resetHorizontalScroll);
  document.addEventListener('shopify:section:load', resetHorizontalScroll);
})();
